<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon
      icon="BellIcon"
      class="cursor-pointer mt-1 sm:mr-6 mr-2"
      :badge="actions.length"
    />
    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ actions.length }} nieuwe</h3>
        <p class="opacity-75">notificaties</p>
      </div>

      <VuePerfectScrollbar
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <component
            v-for="action in actions"
            :key="action.index"
            :is="`${action.action}Notification`"
            :action="action"
          ></component>
        </ul>
      </VuePerfectScrollbar>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";
import MeterReadingRequestNotification from "./Notifications/MeterReadingRequestNotification.vue";
import PossibleContractChangeNotification from "./Notifications/PossibleContractChangeNotification.vue";
import ProposalNotification from "./Notifications/ProposalNotification.vue";
export default {
  components: {
    VuePerfectScrollbar,
    MeterReadingRequestNotification,
    PossibleContractChangeNotification,
    ProposalNotification
  },
  computed: mapState(["actions"])
};
</script>
